import {Component, OnInit, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {Tabs} from '../tabs/tabs.component';
import {Tab} from '../tabs/tab.component';
import {VehiclesPanelComponent} from '../vehicles/vehicles.panel.component';
import {ContractsPanelComponent} from '../contracts/contracts.panel.component';
import {InfractionsPanelComponent} from '../infractions/infractions.panel.component';
import {KmHistoryPanelComponent} from '../kmHistory/kmHistory.panel.component';
import {NavigationService} from '../service/navigation.service';
import {LoginService} from '../service/login.service';
import {User} from '../domain/user';
import {ProceduresPanelComponent} from "../procedures/procedures.panel.component";
import {PatentPaymentPanelComponent} from "../patentPayment/patentPayment.panel.component";
import {AgendaPanelComponent} from "../agenda/agenda.panel.component";
import {PendingProceduresPanelComponent} from "../pendingProcedures/pendingProcedures.panel.component";

@Component({
    selector: 'home-panel',
    template: `
        <tabs>
            <tab [tabTitle]="'Veh&iacute;culos'" [tabName]="'vehicles'" [active]="checkActive('vehicles')"
                 *ngIf="showVehicles">
                <vehicles-panel></vehicles-panel>
            </tab>
            <tab [tabTitle]="'Contratos'" [tabName]="'contracts'" [active]="checkActive('contracts')"
                 *ngIf="showContracts">
                <contracts-panel></contracts-panel>
            </tab>
            <tab [tabTitle]="'Infracciones'" [tabName]="'infractions'" [active]="checkActive('infractions')"
                 *ngIf="showInfractions">
                <infractions-panel></infractions-panel>
            </tab>
            <tab [tabTitle]="'Histórico de km'" [tabName]="'kmHistory'" [active]="checkActive('km_history')"
                 *ngIf="showKmHistory">
                <kmHistory-panel></kmHistory-panel>
            </tab>
            <tab [tabTitle]="'Trámites'" [tabName]="'procedures'" [active]="checkActive('procedures')"
                 *ngIf="showProcedures">
                <procedures-panel></procedures-panel>
            </tab>
            <tab [tabTitle]="'Trámites pendientes'" [tabName]="'pendingProcedures'"
                 [active]="checkActive('pendingProcedures')"
                 *ngIf="showPendingProcedures">
                <pendingProcedures-panel></pendingProcedures-panel>
            </tab>
            <tab [tabTitle]="'Pago de patentes'" [tabName]="'patentPayment'" [active]="checkActive('patentPayment')"
                 *ngIf="showPatentPayment">
                <patentPayment-panel></patentPayment-panel>
            </tab>
            <tab [tabTitle]="'Agenda'" [tabName]="'agenda'" [active]="checkActive('agenda')"
                 *ngIf="showAgenda">
                <agenda-panel></agenda-panel>
            </tab>
        </tabs>
    `,
    directives: [
        Tabs,
        Tab,
        VehiclesPanelComponent,
        ContractsPanelComponent,
        InfractionsPanelComponent,
        KmHistoryPanelComponent,
        ProceduresPanelComponent,
        PendingProceduresPanelComponent,
        PatentPaymentPanelComponent,
        AgendaPanelComponent
    ],
})
export class HomePanel implements OnInit {


    private tabSelected: string;

    private userLogged: User;
    public showVehicles: boolean;
    public showContracts: boolean;
    public showInfractions: boolean;
    public showKmHistory: boolean;
    public showProcedures: boolean;
    public showPatentPayment: boolean;
    public showAgenda: boolean;
    public showPendingProcedures: boolean;


    constructor(private navigationService: NavigationService,
                private loginService: LoginService) {
        this.init();
        let backParameters = navigationService.getBackParameters();
        if (backParameters && backParameters.tabSelected) {
            this.tabSelected = backParameters.tabSelected;
        }
    }

    private init(): void {
        this.showVehicles = false;
        this.showContracts = false;
        this.showInfractions = false;
        this.showKmHistory = false;
        this.showProcedures = false;
        this.showPendingProcedures = false;
        this.showPatentPayment = false;
        this.showAgenda = false;
    }

    public checkActive(tabName: String): boolean {
        if (this.tabSelected) {
            return tabName === this.tabSelected;
        }
        if (this.showVehicles) {
            return tabName === 'vehicles';
        } else if (this.showInfractions) {

            return tabName === 'infractions';
        } else if (this.showKmHistory) {

            return tabName === 'km_history';
        } else if (this.showProcedures) {

            return tabName === 'procedures';
        } else if (this.showPatentPayment) {

            return tabName === 'patentPayment';
        } else if (this.showPendingProcedures) {

            return tabName === 'pendingProcedures';
        } else {

            return tabName === 'agenda';
        }
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        if (!this.userLogged) {
            this.loginService.getUserLoggedSubject().subscribe(
                (userLogged) => {
                    this.userLogged = userLogged;
                    this.updateUserLogged();
                },
                () => {
                    //Do Nothing.
                });
        } else {
            this.updateUserLogged();
        }
    }


    private updateUserLogged(): void {
        this.showVehicles = this.userLogged.canViewSection('VEHICLES');
        this.showContracts = this.userLogged.canViewSection('CONTRACTS');
        this.showInfractions = this.userLogged.canViewSection('INFRACTIONS');
        this.showKmHistory = this.userLogged.canViewSection('KM_HISTORY');
        this.showProcedures = this.userLogged.canViewSection('PROCEDURES');
        this.showPendingProcedures = this.userLogged.canViewSection('AGENDA'); // TODO: Definir quienes podrian ver esta pestaña, ahora solo los que pueden ver agenda y admins
        this.showPatentPayment = this.userLogged.canViewSection('PATENT_PAYMENT');
        this.showAgenda = this.userLogged.canViewSection('AGENDA');
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/home/home.panel.component.ts
 **/